import { createActions } from "redux-actions"

export const { wordpress } = createActions({
  WORDPRESS: {
    GET_ARTICLES: (params, name) => ({ params, name }),
    GET_ARTICLES_RESPONSE: (articles, name) => ({ articles, name }),
  },
})
